import { render, staticRenderFns } from "./Lgx02825680275123197707109.vue?vue&type=template&id=234d2fa0&"
import script from "./Lgx02825680275123197707109.vue?vue&type=script&lang=js&"
export * from "./Lgx02825680275123197707109.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02825680275123197707109.vue?vue&type=style&index=0&id=234d2fa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports